import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { CategoryIcon } from 'owa-categories';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { getCategoryColorsForCategory, getMasterCategoryList } from 'owa-categories';
import { PersonaPill } from 'owa-mail-search-view';
import * as React from 'react';
import { searchStore } from 'owa-mail-search-store';
import { SuggestionKind } from 'owa-search-service';
import { SuggestionSegment } from 'owa-mail-search-view/lib/components/segments/SuggestionSegment';
var styles = require('./SearchBoxPillWell.scss');
var SearchBoxPillWell = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBoxPillWell, _super);
    function SearchBoxPillWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBoxPillWell.prototype.renderPersonaPill = function (pillId, persona) {
        var _this = this;
        return (React.createElement("div", { key: pillId, className: styles.pillContainerCommon },
            React.createElement(PersonaPill, { name: persona.DisplayName, emailAddress: persona.EmailAddresses[0], personaPillId: pillId, onRemoveClick: this.props.onRemovePill, personaType: 'User' }),
            React.createElement(IconButton, { className: styles.removePersonaIcon, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () { return _this.props.onRemovePill(pillId); } })));
    };
    SearchBoxPillWell.prototype.renderCategoryPll = function (pillId, categorySuggestion) {
        var _this = this;
        var categoryName = categorySuggestion.Name;
        var categoryColor = getCategoryColorsForCategory(categoryName, getMasterCategoryList());
        var categoryPillStyle = {
            backgroundColor: categoryColor.primaryColor,
            borderColor: categoryColor.secondaryColor,
            color: categoryColor.textColor,
        };
        var iconStyles = { color: categoryColor.iconColor };
        var iconStylesOnHover = { backgroundColor: categoryColor.secondaryColor };
        return (React.createElement("div", { key: pillId, className: styles.pillContainerCommon, style: categoryPillStyle },
            React.createElement(CategoryIcon, { categoryName: categoryName, iconClassName: styles.categoryIcon }),
            React.createElement("div", { className: styles.categoryPillNameText, title: categoryName }, categoryName),
            React.createElement(Icon, { styles: {
                    root: [
                        iconStyles,
                        styles.removeIconCommon,
                        styles.cancelIcon,
                        {
                            selectors: {
                                '&:hover': iconStylesOnHover,
                            },
                        },
                    ],
                }, iconName: "Cancel" /* Cancel */, onClick: function () { return _this.props.onRemovePill(pillId); } })));
    };
    SearchBoxPillWell.prototype.renderPills = function () {
        var pills = [];
        var length = searchStore.suggestionPillIds.length;
        for (var i = 0; i < length; i++) {
            var pillId = searchStore.suggestionPillIds[i];
            var suggestion = searchStore.suggestionPills.get(pillId);
            if (suggestion.kind == SuggestionKind.People) {
                pills.push(this.renderPersonaPill(pillId, suggestion));
            }
            else if (suggestion.kind == SuggestionKind.Category) {
                pills.push(this.renderCategoryPll(pillId, suggestion));
            }
        }
        return pills;
    };
    SearchBoxPillWell.prototype.renderSegment = function (segment, index) {
        return (React.createElement(SuggestionSegment, tslib_1.__assign({}, { segment: segment, index: index }, { onRemoveSegment: this.props.onRemoveSegment })));
    };
    SearchBoxPillWell.prototype.render = function () {
        return (React.createElement("div", { className: styles.searchBoxPillWell },
            this.renderPills(),
            searchStore.suggestionSegments.map(this.renderSegment.bind(this))));
    };
    SearchBoxPillWell = tslib_1.__decorate([
        observer
    ], SearchBoxPillWell);
    return SearchBoxPillWell;
}(React.Component));
export default SearchBoxPillWell;
//# sourceMappingURL=SearchBoxPillWell.js.map